import { ContainerJourneyResponseDto, ContainerJourneysApi } from '@planning/app/api'
import { createApiClient } from '@planning/app/http-client'
import { Event, IEvent, IQueryHandler, IQueryMessage } from '@tom-ui/utils'

export class GetContainerJourneysQuery implements IQueryMessage {
  static type = 'GetContainerJourneysQuery'
  type = GetContainerJourneysQuery.type

  constructor(
    public containerIds: number[],
    public includeCompleted?: boolean,
    public journeyIds?: number[],
  ) {}

  getKey = () => {
    return JSON.stringify(this)
  }
}

const httpClient = createApiClient(ContainerJourneysApi)

export const getContainerJourneysQueryHandler: IQueryHandler<
  GetContainerJourneysQuery,
  IEvent<ContainerJourneyResponseDto[]>
> = async query => {
  const { data } = await httpClient.getByContainerIds({
    containerIds: query.containerIds,
    includeCompleted: query.includeCompleted,
    includeRestow: true,
    journeyIds: query.journeyIds,
  })

  return new Event(GetContainerJourneysQuery.type, data)
}
